import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Wrapper, Body, ContentList, ContentListItem, ContentText, ContentTitle, Footer } from './styled';

class Extra extends PureComponent {
    render() {
        const { isVillage, pageContent, cityIn } = this.props;

        let titleCeo;
        let listCeo;
        let footerContent;

        if (isVillage) {
            titleCeo = pageContent.titleCeoBlock;
            listCeo = pageContent.listCeoBlock;
            footerContent = pageContent.footerCeoBlock;
        } else {
            titleCeo = pageContent.titleCeoBlock;
            listCeo = pageContent.listCeoBlock;
            listCeo[1] = `Городской Wi-Fi. Бесплатно подключайтесь к точкам Wi-Fi в ${cityIn}. Оставайтесь онлайн, гуляя по городу или ожидая сеанс в кинотеатре.`;
            footerContent = `Если у вас дома много устройств — ноутбук, компьютер, планшет, смартфон — выберите безлимитный тариф интернета по выгодной цене в ${cityIn}, и скорости хватит для решения любых задач.`;
        }

        return (
            <Wrapper>
                <Body>
                    <ContentTitle>{titleCeo}</ContentTitle>
                    <ContentList>
                        {
                            listCeo.map((element, index) => (
                                <ContentListItem key={index} dangerouslySetInnerHTML={{ __html: element }}/>
                            ))
                        }
                    </ContentList>
                    {
                        pageContent.textCeoBlock &&
                        <ContentText>
                            {pageContent.textCeoBlock}
                        </ContentText>
                    }
                </Body>
                <Footer>
                    {footerContent}
                </Footer>
            </Wrapper>
        );
    }
}

Extra.propTypes = {
    pageContent: PropTypes.object,
    cityIn: PropTypes.string,
    cityDomain: PropTypes.string
};

Extra.defaultProps = {
    pageContent: {},
    cityIn: ''
};

export default Extra;
